export default "__VITE_ASSET__aad7e4b4__"